import { defineComponent as _defineComponent } from 'vue'
import PasswordProgress from "@/components/ui/PasswordProgress.vue";
  import useVuelidate from "@vuelidate/core";
  import { helpers, required, sameAs } from "@vuelidate/validators";
  import { validatePassword } from "@/helpers/validation";
  import InputPassword from "@/components/ui/input/InputPassword.vue";
  import { computed, ref } from "vue";
  import router from "@/router";
  import { useStore } from "vuex";
  import {
    confirmPasswordError,
    newPasswordError,
  } from "@/constants/validation";
  import { POSITION, useToast } from "vue-toastification";

  type Action = "activate" | "reset";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'RestorePasswordView',
  setup(__props, { expose: __expose }) {
  __expose();

  const typeAction = router.currentRoute.value.meta.typeAction as Action;
  const mapActions = {
    reset: "user/changePassword",
    activate: "user/activatePassword",
  };
  const store = useStore();
  const toast = useToast();
  const errorMessage = ref("");

  const form = ref({
    password: "",
    confirmPassword: "",
  });
  const rules = computed(() => ({
    password: {
      required,
      validatePassword: helpers.withMessage(newPasswordError, validatePassword),
    },
    confirmPassword: {
      required,
      sameAsPassword: helpers.withMessage(
        confirmPasswordError,
        sameAs(form.value.password)
      ),
    },
  }));

  const v$ = useVuelidate(rules, form);

  const submitForm = async () => {
    v$.value.$touch();
    const isFormCorrect = await v$.value.$validate();

    if (!isFormCorrect) return;

    await store
      .dispatch(mapActions[typeAction], {
        token: router.currentRoute.value.params.id,
        password: form.value.password,
      })
      .then((res) => {
        toast.success(
          typeAction === "activate"
            ? "The account was activated successfully."
            : "The password was updated successfully.",
          {
            position:
              typeAction === "activate"
                ? POSITION.TOP_LEFT
                : POSITION.TOP_CENTER,
          }
        );
        store.dispatch("user/setUserAndTokens", res.data).then(() => {
          router.push("/");
        });
      })
      .catch((error) => {
        errorMessage.value = error.response.data.message;
      });
  };

const __returned__ = { typeAction, mapActions, store, toast, errorMessage, form, rules, v$, submitForm, PasswordProgress, get useVuelidate() { return useVuelidate }, get helpers() { return helpers }, get required() { return required }, get sameAs() { return sameAs }, get validatePassword() { return validatePassword }, InputPassword, computed, ref, get router() { return router }, get useStore() { return useStore }, get confirmPasswordError() { return confirmPasswordError }, get newPasswordError() { return newPasswordError }, get POSITION() { return POSITION }, get useToast() { return useToast } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})